import React from "react";
import GuideContextProvider from "./components/GatewayForm/GatewayForm.store";
import './app.scss';

export const App = (Component: any) => (props) => (
    <GuideContextProvider>
      <Component {...props} />
    </GuideContextProvider>
  );

export default App